<template>
  <div class="statistics-d">
    <head-top head-title="投票统计" hidden='true' go-back="true"></head-top>
    <p v-if="status === 1 && code === 400" style="padding:200px 10px 0px 10px; text-align: center; font-size:16px">
      {{errMessage}}</p>
    <ul class="statistics-list" v-if="status === 1">
      <li class="sta-li" v-for="(sats,index) in satList" :key="index">
        <div class="line">
          <mt-cell @click.native.prevent="goDetail(sats.areas_id,sats.SatId,typeNum,page, sats.type)">
            <span slot="icon" class="overhidden mint-cell-label">{{sats.title}}</span>
            <span slot="icon" class="mint-cell-label">小区名称：{{sats.areasName}}</span>
            <span slot="icon" class="mint-cell-label">截止时间：{{sats.end_time*1000 | dateFmt('YYYY-MM-DD HH:ss')}}</span>
          </mt-cell>
        </div>
        <div class="tou-song-hui">
          <div class="tou"
               @click="$router.push(`/my/AlreadyVote/${sats.areas_id}/${sats.SatId}/${sats.areasName}/${page}/${sats.type}`)">
            <span>已投票</span>
          </div>
          <div class="song"
               @click="$router.push(`/my/AlreadySendVote/${sats.areas_id}/${sats.SatId}/${sats.areasName}/${page}/${sats.type}`)">
            <span>已送票</span>
          </div>
          <div class="hui"
               @click="$router.push(`/my/AlreadyRecycle/${sats.areas_id}/${sats.SatId}/${sats.areasName}/${page}/${sats.type}`)">
            <span>已回收</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import headTop from '../header/Header.vue'
  import {getVoteList} from '../../api/toupiaotongji'
  import {Toast} from 'mint-ui'

  export default {
    name: 'StatisticsD',
    data() {
      return {
        satList: [],
        status: {
          type: Number
        },
        isFirstEnter: false,
        errMessage: '',
        code: {
          type: Number
        },
        typeNum: {
          type: Number
        },
        page: 'statisticsd'
      }
    },
    created() {
      this.isFirstEnter = true
      this._getSatList()
    },
    // 设置缓存从哪个页面返回
    beforeRouteEnter: (to, from, next) => {
      if (from.name === 'StatisticsDetail' || from.name === 'AlreadyVote' || from.name === 'AlreadySendVote' || from.name === 'AlreadyRecycle') {
        to.meta.isBack = true
      }
      next()
    },
    activated() {
      if (!this.$route.meta.isBack || this.isFirstEnter) {
        this._getSatList()
      }
      this.$route.meta.isBack = false
      this.isFirstEnter = false
    },
    methods: {
      _getSatList() {
        getVoteList().then(res => {
          // console.log(res)
          if (res.code === 200) {
            this.status = res.data.status
            this.typeNum = res.data.type
            this.satList = res.data.sat
            // console.log(this.satList)
          }
          if (res.code === 400) {
            this.status = res.error.status
            this.code = res.code
            this.errMessage = res.error.message
          }
        })
      },
      goDetail(aid, id, type, page, newold) {
        if (type === '2') {
          this.$router.push('/my/StatisticsDDetail/' + aid + '/' + id + '/' + page + '/' + newold)
        } else {
          Toast({
            message: '无权进行房屋操作，只能查看！',
            position: 'middle',
            duration: 1500
          })
        }
      }
    },
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/sass/mixin.scss';

  .statistics-d {
    width: 100%;
    padding-top: 80px;
    .sta-li {
      width: 100%;
      border-bottom: 10px solid #f2f2f2;
      .line {
        margin: 0 10px;
      }
      .overhidden {
        @include ellipsis(1);
        line-height: 22px;
        text-decoration:underline;
      }
      &:last-child {
        border-bottom: none
      }
    }
    .tou-song-hui {
      width: 100%;
      display: inline-flex;
      /*justify-content: space-around;*/
      color: #0078de;
      .tou, .song, .hui {
        width: 33%;
        display: inline;
        text-align: center;
        height: 40px;
        line-height: 40px;
        span {
          padding: 5px 15px;
          border: 1px solid #f2f2f2;
          border-radius: 3px;
        }
      }
    }
    .mint-cell {
      min-height: 70px;
      &:first-child {
        .mint-cell-wrapper {
          background-origin: content-box;
        }
      }
      .mint-cell-wrapper {
        background-size: 100% 0;
        padding: 0;
        margin-bottom: 10px;
      }
      .mint-cell-allow-right::after {
        right: 2px;
      }
    }
    .mint-cell-label {
      margin-top: 0;
      font-size: 14px;
      &:nth-of-type(3) {
        margin-bottom: 6px;
        color: #666;
      }
      &:nth-of-type(2) {
        margin: 6px 0;
        color: #666;
      }
      &:first-child {
        padding: 6px 0 0 0;
        color: rgb(0, 120, 222);
        font-size: 16px;
      }
    }
    .mint-cell-text {
      font-size: 12px;
      color: #666;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/StatisticsD.vue